"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFullscreen = exports.FullscreenProvider = void 0;
var FullscreenProvider_1 = __importDefault(require("./FullscreenProvider"));
exports.FullscreenProvider = FullscreenProvider_1.default;
var useFullscreen_1 = __importDefault(require("./useFullscreen"));
exports.useFullscreen = useFullscreen_1.default;
exports.default = useFullscreen_1.default;
